import Vue from "vue";
import Vuex from "vuex";
import { phoneCaptcha, getMailCode, getUserInfo, logout, myInfo, getProductToken } from "../api/accountManage";
import { removeToken, setToken } from "../tool"
import router from "../router"
import { Message } from 'element-ui';


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: '', // 用来获取主体列表的临时token
    userInfo: {},
    username: null, // 用户名
    phone: null, // 用户手机号
    mail: null, // 用户邮箱
    timeRemaining: 60, // 发送验证码剩余时间
    allow: true, // 是否允许发送验证码
    time: null, // 发送验证码定时器
    isImgVerify: false, // 是否需要图形验证
    business: null, // 图形验证码用的mail/phone
    captchaKey: null, // 图新验证后返回的验证码KEY
    captchaType: null,
    myInfoData: {
      orgList: [],
      orgInfo: {}
    }
  },
  getters: {
    userAgreement: () => '/protocol/platform.html',
    privacyAgreement: () => '/protocol/privacy.html',
    helpCenter: () => "https://iyuanwu.yuque.com/docs/share/89b94d55-1998-42f2-aa95-b5b670ea4074?#",
    userInfo: state => state.userInfo,
    phone: state => state.userInfo.phone,
    mail: state => state.userInfo.mail,
    business: state => state.business,
    timeRemaining: state => state.timeRemaining,
    allow: state => state.allow,
    captchaKey: state => state.captchaKey,
    isImgVerify: state => state.isImgVerify,
    captchaType: state => state.captchaType,
    myInfoData: state => state.myInfoData
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    // 设置验证码key
    SET_CAPTCHA_KEY: (state, key) => {
      state.captchaKey = key
    },
    // 设置验证码对应的类型
    SET_CAPTCHA_TYPE: (state, type) => {
      state.captchaType = type
    },
    // 设置用户信息
    SET_USER_INFO: (state, userInfo) => {
      state.phone = userInfo.phone
      state.mail = userInfo.mail
      state.userInfo = userInfo
    },
    // 设置验证码的手机号码
    SET_BUSINESS: (state, num) => {
      state.business = num
    },
    // 图形验证
    SET_IMG_VERIFY: (state, bool) => {
      state.isImgVerify = bool
    },
    // 修改验证码是否可以发送状态
    SET_SEND_STATUS: (state, bool) => {
      state.allow = bool;
    },
    // 发送验证码剩余时间
    SET_TIME_REMAINING: state => {
      state.timeRemaining--;
      if (state.timeRemaining === -1) {
        clearInterval(state.time);
        state.allow = true;
        state.time = null;
        state.timeRemaining = 60;
      }
    },
    // 手动重置短信发送状态及倒计时
    RESET_SMS: state => {
      clearInterval(state.time);
      state.allow = true;
      state.time = null;
      state.timeRemaining = 60;
    },
    // 设置定时器
    SET_TIMER: (state, time) => {
      state.time = time;
    },
    SET_MY_INFO: (state, data) => {
      state.myInfoData = data;
    }
  },
  actions: {
    // 获取用户信息
    async getUserInfo({ dispatch, commit }) {
      let { data } = await getUserInfo()
      commit("SET_USER_INFO", data)
      dispatch('getMyInfo')
    },
    // 获取用户信息2
    async getMyInfo({ commit }) {
      let { data } = await myInfo();
      commit("SET_MY_INFO", data);
    },
    // 获取验证码
    getCaptcha({ commit, state }, data) {
      commit("SET_CAPTCHA_KEY", null) // 重置
      return new Promise((resolve) => {
        if (state.allow) {
          commit("SET_SEND_STATUS", false);
          if (data.captcha === 'mail') { // 邮箱验证码
            let { mail, type } = data
            mail = mail ? mail : state.mail
            getMailCode({ mail, type }).then(res => {
              resolve(res)
              if (res.data.processImageCode) {
                commit("SET_BUSINESS", mail)
                commit("SET_CAPTCHA_TYPE", type)
                commit("SET_CAPTCHA_KEY", res.data.captchaKey)
                commit("SET_IMG_VERIFY", true)
              }
              Message({
                type: "success",
                message: "验证码发送成功"
              })
              state.time = setInterval(() => {
                commit("SET_TIME_REMAINING");
              }, 1000);
            }).catch(() => {
              commit("SET_SEND_STATUS", true);
            })
          } else { // 手机验证码
            let { phone, type } = data
            phone = phone ? phone : state.phone
            phoneCaptcha({ phone, type }).then(res => {
              resolve(res)
              if (res.data.processImageCode) {
                commit("SET_BUSINESS", phone)
                commit("SET_CAPTCHA_TYPE", type)
                commit("SET_CAPTCHA_KEY", res.data.captchaKey)
                commit("SET_IMG_VERIFY", true)
              } else {
                state.time = setInterval(() => {
                  commit("SET_TIME_REMAINING");
                }, 1000);
                Message({
                  type: "success",
                  message: "验证码发送成功"
                })
              }
            }).catch(() => {
              commit("SET_SEND_STATUS", true);
            })
          }
        }
      })
    },
    // 登录后跳转地址
    goIndex(isWeixin) {
      if (isWeixin) {
        parent.location.href = process.env.VUE_APP_INDEX_URL
      } else {
        window.location.href = process.env.VUE_APP_INDEX_URL
      }
    },
    // 退出登录
    logout() {
      logout()
        .then(() => {
          removeToken()
          router.push("/")
        })
        .catch(() => {
          removeToken()
          router.push("/")
        });
    },
    async ProductToken() {
      let ProductData = await getProductToken().catch(); // 获取供应链token
      let accessTokenProduct = ProductData?.data?.accessTokenProduct;
      setToken("accessTokenProduct", accessTokenProduct ? accessTokenProduct : "");
    }
  },
  modules: {},
});
